import { useEffect } from 'react'
import { useAccountSource } from '@/src/renderer/lib/accountSource'
import { flushPendingOnboardingResponse } from '@/src/renderer/lib/onboarding/onboardingResponse'

/**
 * Schickt beim Start einmal die Setup-Antworten nach, die beim Setup nicht
 * rausgingen (kein Netz, Fensterwechsel) — siehe `onboardingResponse.ts`.
 * Nur im Hauptfenster: Nebenfenster teilen sich den Merker und schickten sonst
 * doppelt.
 */
export function usePendingOnboardingResponse(enabled: boolean): void {
  const account = useAccountSource()
  useEffect(() => {
    if (!enabled) return
    void flushPendingOnboardingResponse(row => account.submitAnonymousOnboarding(row))
  }, [enabled, account])
}
